import { LoadingContext } from "@/contexts/LoadingContext/LoadingContext";
import { useContext } from "react";

export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context)
    throw new Error("Please use within bounds of Loading Context Provider.");
  return context;
};
